import { Suspense, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Spinner } from '../lib';
import { DashboardLayout } from './DashboardLayout';
import AdminDuesPaymentPage from './pages/AdminDuesPaymentsPage';
import DuesPmtPage from './pages/DuesPaymentsPage';
import DuesPmtSuccessPage from './pages/DuesPmtSuccessPage';
import DuesReceiptPage from './pages/DuesReceipt';
import FeedbackPage from './pages/FeedbackPage';
import JobHistoryPage from './pages/JobHistoryPage';
import JobOfferPage from './pages/JobOfferPage';
import LoginPage from './pages/LoginPage';
import MemberAvailabilityPage from './pages/MemberAvailabilityPage';
import MemberInfoPage from './pages/MemberInfoPage';
import RegisterPage from './pages/RegisterPage';
import TextMembersOnJob from './pages/TextMembersonJob';
import { TimesheetPage } from './pages/TimesheetPage';
import WageHistoryPage from './pages/WageHistoryPage';
import MemberSkillsPage from  './pages/MemberSkillsPage';
import StewardReportPage from './pages/StewardReportPage';
import CrewListBriefPage from './pages/CrewListBriefPage';
import RoleAdminPage from './pages/RoleAdminPage';
import SupportNewTicketPage from './pages/SupportNewTicketPage';
import SupportMyTicketsPage from './pages/SupportMyTicketsPage';
import SupportTicketDetailPage from './pages/SupportTicketDetailPage';
import SupportQueuePage from './pages/SupportQueuePage';
import SupportAdminPage from './pages/SupportAdminPage';
import SupportBoardPage from './pages/SupportBoardPage';
import SupportDelegationsPage from './pages/SupportDelegationsPage';
import SupportMemberHistoryPage from './pages/SupportMemberHistoryPage';
import SupportSnippetsPage from './pages/SupportSnippetsPage';
import LeadershipDashboardPage from './pages/LeadershipDashboardPage';
import DocumentAdminPage from './pages/DocumentAdminPage';
import DocumentConfigurePage from './pages/DocumentConfigurePage';
import DocumentRosterPage from './pages/DocumentRosterPage';
import DocumentsPage from './pages/DocumentsPage';
import DocumentViewerPage from './pages/DocumentViewerPage';
import StepUpVerifyPage from './pages/StepUpVerifyPage';
import { TICKET_STAFF_ROLES } from './pages/supportShared';
import { RequirePortalRoles } from './providers/portalAccess';
import {
  RequireAuthenticated,
  RequireUnAuthenticated,
  useAuth,
} from './providers/auth';

export const ROLE_ADMIN = 'Admin';
export const ROLE_BETA = 'Beta';
export const ROLE_OFFICE_PMTS = 'Office_Pmts';
export const ROLE_STEWARD_TEXT = 'Steward_Text';
export const ROLE_STEWARD = 'Steward';
export const ROLE_FRONT_DESK = 'FrontDesk';
export const ROLE_BAN_AUTHORITY = 'BanAuthority';
export const ROLE_DOCUMENT_ADMIN = 'DocumentAdmin';
export const ROLE_DASHBOARD_VIEWER = 'DashboardViewer';

export const Root = () => {
  const auth = useAuth();
  const [navbarCollapse, setnavbarCollapse] = useState(false);

  const handleNavBarClick = () => {
    setnavbarCollapse(!navbarCollapse);
  };

  const { pathname } = useLocation();

  return (
    <DashboardLayout>
      <Suspense
        fallback={
          <div className="flex h-full items-center justify-center">
            <Spinner />
          </div>
        }
      >
        <Routes>
          <Route
            key="/login"
            path="/login"
            element={
              <RequireUnAuthenticated redirect>
                <LoginPage />
              </RequireUnAuthenticated>
            }
          />
          <Route
            key="/register"
            path="/register"
            element={
              <RequireUnAuthenticated redirect>
                <RegisterPage />
              </RequireUnAuthenticated>
            }
          />

          <Route
            path="/info"
            element={
              <RequireAuthenticated redirect>
                <MemberInfoPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/jobhist"
            element={
              <RequireAuthenticated redirect>
                <JobHistoryPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/wagehist"
            element={
              <RequireAuthenticated redirect>
                <WageHistoryPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/payment-success/:sessionid"
            element={
              <RequireAuthenticated redirect>
                <DuesPmtSuccessPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/dues-admin"
            element={
              <RequirePortalRoles redirect roles={[ROLE_OFFICE_PMTS]}>
                <AdminDuesPaymentPage />
              </RequirePortalRoles>
            }
          />

          <Route
            path="/dues-receipt/:sessionid"
            element={
              <RequireAuthenticated redirect>
                <DuesReceiptPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/dues"
            element={
              <RequireAuthenticated redirect>
                <DuesPmtPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/timesheet"
            element={
              <RequirePortalRoles redirect roles={[ROLE_BETA]}>
                <TimesheetPage />
              </RequirePortalRoles>
            }
          />

          <Route
            path="/avail"
            element={
              <RequireAuthenticated redirect>
                <MemberAvailabilityPage />
              </RequireAuthenticated>
            }
          />


        <Route
            path="/skills"
            element={
              <RequireAuthenticated redirect>
                <MemberSkillsPage />
              </RequireAuthenticated>
            }/>

          <Route
            path="/feedback"
            element={
              <RequireAuthenticated redirect>
                <FeedbackPage />
              </RequireAuthenticated>
            }
          />

          <Route path="/offer/:shortCode" element={<JobOfferPage />} />

          <Route path="/o/:shortCode" element={<JobOfferPage />} />

          <Route
            path="/steward-report"
            element={
              <RequirePortalRoles redirect roles={[ROLE_STEWARD]}>
                <StewardReportPage />
              </RequirePortalRoles>
            }
          />

          <Route
            path="/crew-list"
            element={
              <RequirePortalRoles redirect roles={[ROLE_STEWARD]}>
                <CrewListBriefPage />
              </RequirePortalRoles>
            }
          />

          <Route
            path="/"
            element={
              <RequireAuthenticated redirect>
                <MemberInfoPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/text-members-on-job"
            element={
              <RequirePortalRoles redirect roles={[ROLE_STEWARD_TEXT, ROLE_STEWARD]}>
                <TextMembersOnJob />
              </RequirePortalRoles>
            }
          />

          <Route
            path="/role-admin"
            element={
              <RequirePortalRoles redirect roles={[ROLE_ADMIN]}>
                <RoleAdminPage />
              </RequirePortalRoles>
            }
          />
          <Route
            path="/doc-admin"
            element={
              <RequirePortalRoles redirect roles={[ROLE_DOCUMENT_ADMIN]}>
                <DocumentAdminPage />
              </RequirePortalRoles>
            }
          />

          {/* D4: per-document acknowledgment roster + live count */}
          <Route
            path="/doc-admin/roster/:id"
            element={
              <RequirePortalRoles redirect roles={[ROLE_DOCUMENT_ADMIN]}>
                <DocumentRosterPage />
              </RequirePortalRoles>
            }
          />

          {/* D5: per-document configure page (Form I — publish, review mode,
              audience, due date) */}
          <Route
            path="/doc-admin/doc/:id"
            element={
              <RequirePortalRoles redirect roles={[ROLE_DOCUMENT_ADMIN]}>
                <DocumentConfigurePage />
              </RequirePortalRoles>
            }
          />

          {/* D2: step-up identity check — document pages route here on a
              403 StepUpRequired with ?returnTo=<path> */}
          <Route
            path="/verify"
            element={
              <RequireAuthenticated redirect>
                <StepUpVerifyPage />
              </RequireAuthenticated>
            }
          />

          {/* D3: member document area at /docs — the /documents prefix
              belongs to the API the viewer's <img> tags fetch from */}
          <Route
            path="/docs"
            element={
              <RequireAuthenticated redirect>
                <DocumentsPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/docs/:id"
            element={
              <RequireAuthenticated redirect>
                <DocumentViewerPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/help"
            element={
              <RequireAuthenticated redirect>
                <SupportMyTicketsPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/help/new"
            element={
              <RequireAuthenticated redirect>
                <SupportNewTicketPage />
              </RequireAuthenticated>
            }
          />

          {/* T4: /help/new/:category renders that category's form */}
          <Route
            path="/help/new/:category"
            element={
              <RequireAuthenticated redirect>
                <SupportNewTicketPage />
              </RequireAuthenticated>
            }
          />

          <Route
            path="/help/ticket/:id"
            element={
              <RequireAuthenticated redirect>
                <SupportTicketDetailPage />
              </RequireAuthenticated>
            }
          />

          {/* T5: staff lanes include the BR/ABR escalation queues; delegated
              lanes ride /portal/access for their date range. Cosmetic — the
              server re-checks every listing. */}
          <Route
            path="/help/queue"
            element={
              <RequirePortalRoles redirect roles={TICKET_STAFF_ROLES}>
                <SupportQueuePage />
              </RequirePortalRoles>
            }
          />

          <Route
            path="/help/board"
            element={
              <RequirePortalRoles redirect roles={TICKET_STAFF_ROLES}>
                <SupportBoardPage />
              </RequirePortalRoles>
            }
          />

          <Route
            path="/help/snippets"
            element={
              <RequirePortalRoles redirect roles={TICKET_STAFF_ROLES}>
                <SupportSnippetsPage />
              </RequirePortalRoles>
            }
          />

          <Route
            path="/help/delegations"
            element={
              <RequirePortalRoles redirect roles={TICKET_STAFF_ROLES}>
                <SupportDelegationsPage />
              </RequirePortalRoles>
            }
          />

          {/* S1: a member's running record — staff lanes only; the server
              filters every row through CanWorkTicket for the viewer */}
          <Route
            path="/help/member/:id"
            element={
              <RequirePortalRoles redirect roles={TICKET_STAFF_ROLES}>
                <SupportMemberHistoryPage />
              </RequirePortalRoles>
            }
          />

          {/* S1: leadership dashboard — aggregate numbers only, gated on
              DashboardViewer (Admin implicit) */}
          <Route
            path="/help/dashboard"
            element={
              <RequirePortalRoles redirect roles={[ROLE_DASHBOARD_VIEWER]}>
                <LeadershipDashboardPage />
              </RequirePortalRoles>
            }
          />

          {/* T7: conduct controls — banned-term list + ticket bans (the
              server gates every endpoint on BanAuthority; Admin implicit) */}
          <Route
            path="/help/admin"
            element={
              <RequirePortalRoles redirect roles={[ROLE_BAN_AUTHORITY]}>
                <SupportAdminPage />
              </RequirePortalRoles>
            }
          />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </DashboardLayout>
  );
};
